import request from './base';

const Api = {
    /**
     * 获取课程列表
     * @param keyword
     * @param statusCode
     * @param typeCode
     * @param lecturerId
     * @param sort
     * @param pageIndex
     * @param pageSize
     * @returns {Promise | Promise<unknown>}
     */
    getCourseList: ({keyword, statusCode, typeCode, lecturerId, sort = 2, pageIndex = 1, pageSize = 10}) => {
        return request.get('Course/GetPageList', {
            keyword,
            statusCode,
            typeCode,
            lecturerId,
            sort,
            pageIndex,
            pageSize
        })
    },

    /**
     * 获取课程信息
     * @param courseId
     * @returns {Promise<unknown>}
     */
    getCourseInfo: (courseId) => {
        return request.get('/Course/Get', {courseId})
    },

    /**
     * 创建修改课程
     * @param courseId
     * @param courseName
     * @param lecturerIds
     * @param sectionCode
     * @param subjectCode
     * @param gradeCode
     * @param versionCode
     * @param labels
     * @param coverImg
     * @param typeCode
     * @param infoTypeCode
     * @param filePaths
     * @param totalNumber
     * @returns {*}
     */
    createUpdateCourse: ({
                             courseId,
                             courseName,
                             lecturerIds = [],
                             sectionCode = 0,
                             subjectCode = 0,
                             gradeCode = 0,
                             versionCode = 0,
                             labels = [],
                             coverImg,
                             typeCode = 0,
                             infoTypeCode = 0,
                             filePaths = [],
                             totalNumber = 0
                         }) => {
        return request.post('/Course/Edit', {
            courseId,
            courseName,
            lecturerIds,
            sectionCode,
            subjectCode,
            gradeCode,
            versionCode,
            labels,
            coverImg,
            typeCode,
            infoTypeCode,
            filePaths,
            totalNumber
        })
    },

    /**
     * 修改课程上架状态
     * @param courseId
     * @param statusCode 1上架  -1下架
     * @returns {Promise | Promise<unknown>}
     */
    updateCourseStatus: (courseId, statusCode) => {
        return request.post('/Course/UpdateStatus',{
            courseId,
            statusCode
        })
    },

    /**
     * 系列课程的目录
     * @param courseId
     * @returns {Promise<unknown>}
     */
    getCourseCatalogue: (courseId) => {
        return request.get('/CourseInfo/GetList', {courseId})
    },

    /**
     * 创建修改目录/内容
     * @param courseInfoId
     * @param courseInfoName
     * @param parentId
     * @param courseId
     * @param coverImg
     * @param typeCode
     * @param filePaths
     * @param totalNumber
     * @returns {Promise<unknown>}
     */
    createUpdateCourseInfo: ({
                                 courseInfoId = 0,
                                 courseInfoName,
                                 parentId = 0,
                                 courseId = 0,
                                 coverImg,
                                 typeCode = 0,
                                 filePaths=[],
                                 totalNumber = 0
                             }) => {
        return request.post('/CourseInfo/Edit', {
            courseInfoId,
            courseInfoName,
            parentId,
            courseId,
            coverImg,
            typeCode,
            filePaths,
            totalNumber
        })
    },

    /**
     * 修改目录排序
     * @param courseInfoId
     * @param sort
     */
    updateCourseInfoSort: (courseInfoId, sort)=>{
        return request.post('/CourseInfo/UpdateSort', {
            courseInfoId,
            sort
        })
    },

    /**
     * 删除目录/内容
     * @param courseInfoId
     * @param courseId
     * @returns {Promise<unknown>}
     */
    deleteCourseInfo: (courseInfoId, courseId) => {
        return request.delete('/CourseInfo/Delete',{
            courseInfoId,
            courseId
        })
    },

    /**
     * 获取讲师列表
     * @param lecturerName
     * @param pageIndex
     * @param pageSize
     * @returns {Promise<unknown>}
     */
    getLecturerList: ({lecturerName, pageIndex = 1, pageSize = 10}) => {
        return request.get('/Lecturer/GetPageList', {
            lecturerName,
            pageIndex,
            pageSize
        })
    },

    /**
     *
     * @param lecturerId
     * @returns {Promise | Promise<unknown>}
     */
    getLecturerInfo: (lecturerId) => {
        return request.get('/Lecturer/Get', {lecturerId})
    },

    /**
     * 新增/修改 讲师信息
     * @param lecturerId
     * @param lecturerName
     * @param headImg
     * @param title
     * @param introduce
     * @param coursesNumber
     * @param fansNumber
     * @returns {Promise<unknown>}
     */
    createUpdateLecturer: ({
                               lecturerId = 0,
                               lecturerName,
                               headImg,
                               title,
                               introduce
                           }) => {

        return request.post('/Lecturer/Edit', {
            lecturerId,
            lecturerName,
            headImg,
            title,
            introduce
        })
    },

    /**
     * 获取学员列表
     * @param studentId
     * @param nickName
     * @param mobile
     * @param pageIndex
     * @param pageSize
     * @returns {Promise<unknown>}
     */
    getStudentList: ({
                         studentId,
                         nickName,
                         mobile,
                         pageIndex = 0,
                         pageSize = 10

                     }) => {
        return request.get('/Student/GetPageList', {
            studentId,
            nickName,
            mobile,
            pageIndex,
            pageSize
        })
    },

    /**
     * 获取学生观看记录
     * @param studentId
     * @param pageIndex
     * @param pageSize
     * @returns {Promise<unknown>}
     */
    getStudentLearnList: ({
                studentId,
                pageIndex = 0,
                pageSize = 8

            }) => {
        return request.get('/Student/GetPageLearnList', {
            studentId,
            pageIndex,
            pageSize
        })
    },
  /**
     * 获取图库列表
     * @returns {Promise<unknown>}
     */
    
    getPictureLibList: () => {
        return request.get('/PictureLib/GetList')
    },

      /**
     * 批量上传
     * @param array  [{titles,picUrls}]
     * @returns {Promise<unknown>}
     */
      pictureLibBatchAdd: (array) => {

        return request.post('/PictureLib/BatchAdd', array)
    },

    /**
         * 删除学校图库
         * @param titles
         * @param picUrls
         * @returns {Promise<unknown>}
         */
    deletePictureLib: (id) => {
        return request.delete('/PictureLib/delete',{
            id,
        })
    },

    /**
     * 新增学校图库/修改
     * @param id
     * @param title
     * @param picUrl
     * @returns {Promise<unknown>}
     */
    editPictureLib: ({id,title,picUrl}) => {
        return request.post('/PictureLib/Edit',{
            id,
            title,
            picUrl
        })
    },
}


export default Api